import { Link } from 'react-router-dom';

const footerLinks = {
  产品系列: [
    { label: '冰川之源系列', path: '/categories/glacier-source' },
    { label: '雪山灵泉系列', path: '/categories/snow-spring' },
    { label: '珍藏限量系列', path: '/categories/limited-edition' },
  ],
  品牌资讯: [
    { label: '品牌故事', path: '/articles/kunlun-snow-brand-story' },
    { label: '健康科普', path: '/articles/kunlun-glacier-water-health-benefits' },
    { label: '选购指南', path: '/articles/how-to-choose-premium-mineral-water' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '荣誉资质', path: '/about#honors' },
    { label: '联系方式', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center text-background-50 font-heading font-bold text-sm">
                雪
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                昆仑雪
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mt-3">
              源自昆仑山万年冰川雪水精华，以极致纯净为核心理念，为您带来来自世界屋脊的天然馈赠。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 昆仑雪 Kunlun Snow. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer text-xs whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer text-xs whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer text-xs whitespace-nowrap" rel="nofollow">
              Cookie政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}